module.exports = __webpack_public_path__ + "static/day01-0469f0d2c5180f473e4a82ce9c724b42.png";